export const fontSizeForSlider = value => {
  const parsed = parseFloat(value);
  return Number.isFinite(parsed) ? parsed : 0.95;
};
